import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';

interface AppLoadingScreenProps {
  message?: string;
  isWakingUp?: boolean;
}

/**
 * App Loading Screen Component
 * Splash screen'den sonra gösterilen yükleme ekranı
 * Splash screen ile uyumlu renk şeması kullanır (#181121)
 */
export const AppLoadingScreen: React.FC<AppLoadingScreenProps> = ({ 
  message = 'Uygulama başlatılıyor...',
  isWakingUp = false
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <ActivityIndicator size="large" color="#FFFFFF" />
        <Text style={styles.title}>
          {isWakingUp ? 'Sunucu uyandırılıyor...' : 'VerifyGate'}
        </Text>
        <Text style={styles.message}>{message}</Text>
        {isWakingUp && (
          <Text style={styles.subMessage}>
            Bu işlem 30-50 saniye sürebilir
          </Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#181121', // Splash screen ile uyumlu koyu mor arka plan
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    alignItems: 'center',
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#FFFFFF', // Koyu arka plan için beyaz text
    marginTop: 20,
    marginBottom: 10,
  },
  message: {
    fontSize: 16,
    color: '#E2E8F0', // Açık gri text (slate-200)
    textAlign: 'center',
    marginTop: 10,
  },
  subMessage: {
    fontSize: 14,
    color: '#CBD5E1', // Daha açık gri (slate-300)
    textAlign: 'center',
    marginTop: 5,
    fontStyle: 'italic',
  },
});

export default AppLoadingScreen;

